import { createContext } from 'react';

import type {
  TransactionStatus,
  TransactionType,
} from '@/lib/heyapi/types.gen';

export const CurrentTransactionContext = createContext<{
  currentTransactionStatus: TransactionStatus | null | undefined;
  currentTransactionType: TransactionType | null | undefined;
  currentTransactionEffectiveDate: string | null | undefined;
  isChangeExpirationDateMidterm: boolean;
  // DC-3069: optional with safe defaults so providers that omit them
  // (e.g. test providers) still satisfy the type. Falsy isMidtermEndorsement
  // is treated as "no append" by consumers (append alert hidden).
  currentTransactionNumber?: number | null | undefined;
  isMidtermEndorsement?: boolean;
}>({
  currentTransactionStatus: null,
  currentTransactionType: null,
  currentTransactionEffectiveDate: null,
  isChangeExpirationDateMidterm: false,
  currentTransactionNumber: null,
  isMidtermEndorsement: false,
});
